export const ID_MODAL_INSTALL_THEME_SHOPIFY = 'ID_MODAL_INSTALL_THEME_SHOPIFY';
export const ID_MODAL_INSTALL_THEME_EVANTO = 'ID_MODAL_INSTALL_THEME_EVANTO';
